module.exports = __webpack_public_path__ + "static/media/cloud1@2x.730b3951.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/cloud1@2x.png
// module id = 867
// module chunks = 0